"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgSnowflake = function SvgSnowflake(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M9 9.735v2.847l1.707 1.708a1 1 0 11-1.414 1.414l-1.29-1.29-1.297 1.291a1 1 0 01-1.412-1.416L7 12.589V9.734l-2.443 1.422-.621 2.332a.992.992 0 01-1.215.707 1 1 0 01-.702-1.225l.469-1.763-1.754-.477a1 1 0 01-.7-1.226.992.992 0 011.217-.705l2.308.627L6.015 8l-2.45-1.426-2.316.624A.992.992 0 01.034 6.49a1 1 0 01.702-1.225l1.75-.472-.468-1.768A1 1 0 012.722 1.8a.992.992 0 011.214.709l.616 2.328L7 6.262V3.415L5.293 1.707A1 1 0 116.707.293l1.29 1.29L9.295.293a1 1 0 111.412 1.416L9 3.408v2.854l2.443-1.421.621-2.333a.992.992 0 011.215-.707 1 1 0 01.702 1.225l-.469 1.763 1.754.477a1 1 0 01.7 1.226.992.992 0 01-1.217.705l-2.308-.627-2.456 1.429 2.45 1.425 2.316-.624a.992.992 0 011.215.707 1 1 0 01-.702 1.225l-1.75.472.468 1.769a1 1 0 01-.704 1.223.992.992 0 01-1.214-.709l-.616-2.328L9 9.735z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

SvgSnowflake.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgSnowflake;
exports.default = _default;